<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <h1>ГИС ГМП</h1>
      </v-flex>
      <router-view></router-view>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  created: function () {
    this.$store.dispatch('gis_gmpCharge/fetchChargeStatuses')
    this.$store.dispatch('gis_gmpCharge/fetchChargeConditions')
    this.$store.dispatch('gis_gmpCharge/fetchAcknowledgmentStatuses')
    this.$store.dispatch('gis_gmpCharge/fetchKBK')
  }
}

</script>

<style>

</style>
